import { CustomerApplication } from '../../customer-application';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { CustomerInfo } from '../../customer-info';
import { RegisterApplication } from '../../register-application';
import { UpdateApplication } from '../../details/update-application';
import { environment } from '../../../environments/environment';
import { AuditLog } from '../../audit/audit-log';
import { ApplicationLoginLog } from '../../application-login-log/application-login-log';

@Injectable()
export class RestAPIService {
  jwtToken: string = window.localStorage.getItem('JWT_TOKEN');
  private portalPath = environment.portalHostName + environment.portalBaseUrl;

  constructor(private http: HttpClient) { }

  getCustomerInfo(): Promise<CustomerInfo> {
    return this.http.post(this.portalPath + '/validate/customerinfo', null, this.headers(this.jwtToken))
      .toPromise()
      .then(response => response as CustomerInfo)
      .catch(this.handleError);
  }
  getValidationMessages(): Promise<any> {
    return this.http.get(this.portalPath + '/validate/validation-messages', this.headers(this.jwtToken))
      .toPromise()
      .then(response => response)
      .catch(this.handleError);
  }

  getPortalConfigValuesFromS3(data: any): Promise<any> {
    return this.http.post(this.portalPath + '/validate/auth-config-props', data, this.headers(this.jwtToken))
      .toPromise()
      .then(response => response)
      .catch(this.handleError);
  }

  getDashboardDetails(): Promise<any> {
    return this.http.post(this.portalPath + '/dashboard', null, this.headers(this.jwtToken))
      .toPromise()
      .then(response => response)
      .catch(this.handleError);
  }

  getApplications(): Promise<CustomerApplication[]> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + this.jwtToken,
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
      })
    };
    return this.http.get(this.portalPath + '/applications/firm', httpOptions)
      .toPromise()
      .then(response => response as CustomerApplication[])
      .catch(this.handleError);
  }
  registerApplication(application: RegisterApplication): Promise<CustomerApplication> {
    return this.http.post(this.portalPath + '/applications', application, this.headers(this.jwtToken))
      .toPromise()
      .then(response => response as CustomerApplication)
      .catch(this.handleError);
  }

  regenerateApiKey(): Promise<CustomerApplication> {
    return this.http.get(this.portalPath + '/applications/generateapikey', this.headers(this.jwtToken))
      .toPromise()
      .then(response => response as CustomerApplication)
      .catch(this.handleError);
  }
  updateApplication(updateApplication: UpdateApplication, id: number): Promise<CustomerApplication> {
    return this.http.put(this.portalPath + '/application/' + id, updateApplication, this.headers(this.jwtToken))
      .toPromise()
      .then(response => response as CustomerApplication)
      .catch(this.handleError);
  }
  deleteApplication(id: number): Promise<any> {
    return this.http.delete(this.portalPath + '/application/' + id, this.headers(this.jwtToken)).
      toPromise().catch(this.handleError);
  }

  getAuditLogs(): Promise<AuditLog[]> {
    return this.http.get(this.portalPath + '/audit', this.headers(this.jwtToken))
      .toPromise()
      .then(response => response as AuditLog[])
      .catch(this.handleError);
  }


  getApplicationNames(): Promise<any> {
    return this.http.get(this.portalPath + '/applications/names', this.headers(this.jwtToken))
      .toPromise()
      .then(response => response)
      .catch(this.handleError);
  }

  getSuccessfulApplicationLogs(loginLog: any, pageSize: any, pageNo: any, search: any, sortBy: any, sortOrder: any): Promise<any> {
    return this.http.post(this.portalPath + '/loginlogs/successful?pageSize=' + pageSize + '&pageNo=' + pageNo + '&search=' + search + '&sortBy=' + sortBy + '&sortOrder=' + sortOrder, loginLog, this.headers(this.jwtToken))
      .toPromise()
      .then(response => response)
      .catch(this.handleError);
  }

  getFailedApplicationLogs(loginLog: any, pageSize: any, pageNo: any, search: any, sortBy: any, sortOrder: any): Promise<any> {
    return this.http.post(this.portalPath + '/loginlogs/failed?pageSize=' + pageSize + '&pageNo=' + pageNo + '&search=' + search + '&sortBy=' + sortBy + '&sortOrder=' + sortOrder, loginLog, this.headers(this.jwtToken))
      .toPromise()
      .then(response => response as ApplicationLoginLog[])
      .catch(this.handleError);
  }

  updateApplicationLogs(loginLog: any): Promise<any> {
    return this.http.post(this.portalPath + '/loginlogs/updatenoagent', loginLog, this.headers(this.jwtToken))
      .toPromise()
      .then(response => response)
      .catch(this.handleError);
  }

  private handleErrorForAgent(error: any): Promise<any> {
    return Promise.reject(error);
  }

  private handleError(error: any): Promise<any> {
    return Promise.reject(error.json());
  }

  private headers(jwtToken: string) {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    headers = headers.set('Authorization', 'Bearer ' + jwtToken);
    return { headers: headers };
  }
  
}
